export default __webpack_public_path__ + "353d301faa95db9bb7a3403b58ff6545.ttf";